import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../data/pipes/translate.pipe';

@Component({
  selector: 'app-pill-progress-bar',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './pill-progress-bar.component.html',
  styleUrl: './pill-progress-bar.component.scss',
})
export class PillProgressBarComponent implements OnChanges {
  @Input() progress!: number;
  @Input() title!: string;
  @Input() titleIcon!: string;
  @Input() nextTitle!: string;
  @Input() nextTitleIcon!: string;
  @Input() hideInsights = false;
  @Input() isOnDemand = false;

  get leadsToText(): string {
    return this.isOnDemand ? 'WebApp.v1.Shared.Pill.RequestCall.Title' : 'WebApp.v1.Shared.Pill.Insights.Title';
  }

  get leadsToIcon(): string {
    return this.isOnDemand ? 'fa-light fa-mobile-signal-out' : 'fa-solid fa-chart-mixed';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['progress']?.currentValue) {
      this.progress = changes['progress'].currentValue;
    }

    if (changes['title']?.currentValue) {
      this.title = changes['title'].currentValue;
    }

    if (changes['titleIcon']?.currentValue) {
      this.titleIcon = changes['titleIcon'].currentValue;
    }

    if (changes['nextTitle']?.currentValue) {
      this.nextTitle = changes['nextTitle'].currentValue;
    }

    if (changes['nextTitleIcon']?.currentValue) {
      this.nextTitleIcon = changes['nextTitleIcon'].currentValue;
    }

    if (changes['hideInsights']?.currentValue) {
      this.hideInsights = changes['hideInsights'].currentValue;
    }

    if (changes['isOnDemand']?.currentValue) {
      this.isOnDemand = changes['isOnDemand'].currentValue;
    }
  }
}
